import { type PointerEventHandler, type ReactNode } from 'react'

import { type GalleryDisplayType, type GalleryLockSlugType } from '@/defs/gallery'
import { cn } from '@/utils/commonUtil'

import { useGalleryBounce } from '../../hooks/useGalleryBounce'
import { GalleryControlsLock } from '../GalleryControlsLock/GalleryControlsLock'

import styles from './GalleryControlsLockable.module.scss'

type Props = {
  children: ReactNode
  editedKeys: (keyof GalleryDisplayType['edited'])[]
  onPointerEnter?: PointerEventHandler
  slug: GalleryLockSlugType
}

export const GalleryControlsLockable = ({ children, editedKeys, onPointerEnter, slug }: Props) => {
  const isBouncing = useGalleryBounce({ editedKeys })

  return (
    <div className={cn(styles.container, { isBouncing, styles })} onPointerEnter={onPointerEnter}>
      <div className={styles.control}>{children}</div>
      <div className={styles.lock}>
        <GalleryControlsLock slug={slug} />
      </div>
    </div>
  )
}
